import { render, staticRenderFns } from "./Voids.vue?vue&type=template&id=9b1f1806"
import script from "./Voids.vue?vue&type=script&lang=js"
export * from "./Voids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports